import React from 'react';
import Icon from '../../../../../muiComponents/Icon';

interface NavigationDotsProps {
    totalDots: number;
    activeIndex: number;
    onDotClick: (index: number) => void;
}

const NavigationDots = (props: NavigationDotsProps) => {
    const { totalDots, activeIndex, onDotClick } = props;

    return (
        <div className='navigation-dots'>
            {totalDots > 1 &&
                Array.from({ length: totalDots }).map((_, idx) => (
                    <Icon
                        key={idx}
                        iconName='FiberManualRecord'
                        onClick={() => onDotClick?.(idx)}
                        className={
                            'navigation-dot' +
                            (activeIndex === idx ? ' --active' : '')
                        }
                    />
                ))}
        </div>
    );
};

export default NavigationDots;
